module.exports = __webpack_public_path__ + "static/media/Search_Button_Active.fecb24a7.png";